/*
  The header (sections/header.liquid, 2026-09-28). One file, no library:
    - the bar hides while reading down and returns on the way up; .is-compact on #crk-header while it is stuck
      and showing (the product page reads its height into --crk-stick), --header-height = its visible bottom
      (the cart page's rail), and a 'crk:header' event after every change (the collection bar re-measures);
    - a straw hairline for how far down the page is;
    - the menu: a highlight that glides to the item under the pointer; a panel per group that opens on hover
      (with intent, so a pass across the menu opens nothing) and on the caret button, keyboard and Esc;
    - search: the overlay opens from the pill, the icon, "/" or Ctrl/Cmd K, and the pill's hint rotates
      through the popular searches;
    - the phone drawer, with its focus kept inside, and the phone ticker showing one fact at a time.
  Images inside the panels, the search and the drawer carry data-src and load on first use.
*/
(() => {
  'use strict';
  const wrap = document.querySelector('.crk-hdr-wrap');
  const hdr = document.getElementById('crk-header');
  if (!wrap || !hdr) return;
  const doc = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
  const sticky = hdr.dataset.sticky !== 'false';
  const $ = (s, c) => (c || wrap).querySelector(s);
  const $$ = (s, c) => Array.from((c || wrap).querySelectorAll(s));
  const loadImgs = (box) => $$('img[data-src]', box).forEach((i) => { i.src = i.dataset.src; i.removeAttribute('data-src'); });
  const tell = () => document.dispatchEvent(new CustomEvent('crk:header'));

  /* ---------- sticky: hide on the way down, show on the way up ---------- */
  let lastY = window.scrollY, raf = 0, away = false, down = 0;
  const panelsOpen = () => wrap.classList.contains('is-finding') || wrap.classList.contains('is-menu') || !!$('.crk-hdr__item.is-open');
  function frame() {
    raf = 0;
    const y = window.scrollY;
    const tick = wrap.querySelector('.crk-tick') ? wrap.querySelector('.crk-tick').offsetHeight : 0;
    const stuck = y > tick;
    const dy = y - lastY;
    /* it hides only after a sustained 120px on the way down, so a small scroll never makes it twitch */
    down = dy > 0 ? down + dy : 0;
    if (sticky && !panelsOpen()) {
      if (down > 120 && y > tick + hdr.offsetHeight + 60) away = true;
      else if (dy < -6 || y <= tick) away = false;
    } else away = false;
    lastY = y;
    const was = wrap.classList.contains('is-away'), wasC = hdr.classList.contains('is-compact');
    wrap.classList.toggle('is-away', away);
    hdr.classList.toggle('is-compact', stuck && !away);
    const bottom = away ? 0 : Math.max(0, hdr.getBoundingClientRect().bottom);
    doc.style.setProperty('--header-height', Math.round(bottom) + 'px');
    const max = doc.scrollHeight - window.innerHeight;
    hdr.style.setProperty('--prog', max > 0 ? Math.min(1, y / max).toFixed(4) : 0);
    if (was !== away || wasC !== hdr.classList.contains('is-compact')) tell();
  }
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(frame); };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  wrap.addEventListener('transitionend', (e) => { if (e.target === wrap) { frame(); tell(); } });
  frame();

  /* ---------- the menu ---------- */
  const nav = $('[data-nav]');
  const glide = $('.crk-hdr__glide');
  function glideTo(el) {
    if (!nav || !glide) return;
    if (!el) { nav.classList.remove('is-gliding'); return; }
    /* the highlight is placed against the header, the box it is positioned in */
    const n = hdr.getBoundingClientRect(), r = el.getBoundingClientRect();
    glide.style.setProperty('--gx', (r.left - n.left) + 'px');
    glide.style.setProperty('--gw', r.width + 'px');
    nav.classList.add('is-gliding');
  }
  const items = $$('[data-item]');
  let openT = 0, closeT = 0;
  function setOpen(item, on) {
    items.forEach((it) => {
      const want = on && it === item;
      if (it.classList.contains('is-open') === want) return;
      it.classList.toggle('is-open', want);
      const b = $('.crk-hdr__caret', it); if (b) b.setAttribute('aria-expanded', String(want));
      if (want) loadImgs(it);
    });
    wrap.classList.toggle('is-dim', !!(on && item && item.querySelector('.crk-mega')));
  }
  function closeAll() { clearTimeout(openT); setOpen(null, false); }
  items.forEach((it) => {
    const top = $('.crk-hdr__top', it);
    const unit = () => {
      /* the highlight covers the link and its caret together */
      const a = top.getBoundingClientRect(), c = $('.crk-hdr__caret', it);
      if (!c) return top;
      const b = c.getBoundingClientRect();
      return { getBoundingClientRect: () => ({ left: a.left, width: b.right - a.left }) };
    };
    it.addEventListener('mouseenter', () => {
      if (!hoverMq.matches) return;
      glideTo(unit());
      clearTimeout(closeT);
      if (!it.classList.contains('has-panel')) { openT = setTimeout(() => setOpen(null, false), 120); return; }
      clearTimeout(openT);
      openT = setTimeout(() => setOpen(it, true), $('.crk-hdr__item.is-open') ? 0 : 110);
    });
    it.addEventListener('mouseleave', () => { if (hoverMq.matches) { clearTimeout(openT); } });
    top.addEventListener('focus', () => glideTo(unit()));
    const caret = $('.crk-hdr__caret', it);
    if (caret) caret.addEventListener('click', () => setOpen(it, !it.classList.contains('is-open')));
    it.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && it.classList.contains('is-open')) { e.stopPropagation(); setOpen(null, false); if (caret) caret.focus(); }
      if (e.key === 'ArrowDown' && caret && (e.target === top || e.target === caret)) {
        e.preventDefault(); setOpen(it, true);
        const first = $('.crk-mega a, .crk-drop a', it); if (first) setTimeout(() => first.focus(), 30);
      }
    });
  });
  if (nav) nav.addEventListener('mouseleave', () => glideTo(null));
  /* the panels' pictures start loading as soon as the pointer comes to the menu */
  if (nav) nav.addEventListener('mouseenter', () => loadImgs(nav), { once: true });
  /* leaving the row and its open panel closes it, after a moment */
  hdr.addEventListener('mouseleave', () => { if (!hoverMq.matches) return; clearTimeout(openT); closeT = setTimeout(() => setOpen(null, false), 220); });
  hdr.addEventListener('mouseenter', () => clearTimeout(closeT));
  /* focus leaving an open item closes it */
  hdr.addEventListener('focusout', (e) => {
    const open = $('.crk-hdr__item.is-open');
    if (open && e.relatedTarget && !open.contains(e.relatedTarget)) setOpen(null, false);
  });

  /* ---------- search ---------- */
  const find = $('[data-find]');
  const input = find ? $('input[type="search"]', find) : null;
  let findFrom = null;
  function setFind(on, from) {
    if (!find) return;
    if (on === wrap.classList.contains('is-finding')) return;
    closeAll();
    wrap.classList.toggle('is-finding', on);
    wrap.classList.toggle('is-dim', on);
    $$('[data-find-open]').forEach((b) => b.setAttribute('aria-expanded', String(on)));
    const phone = window.matchMedia('(max-width: 989px)').matches;
    doc.classList.toggle('crk-hdr-lock', on && phone);
    find.setAttribute('aria-modal', String(phone));
    if (on) {
      findFrom = from || document.activeElement;
      loadImgs(find);
      wrap.classList.remove('is-away');
      setTimeout(() => { if (input) { input.focus({ preventScroll: true }); input.select(); } }, reduce ? 0 : 60);
    } else if (findFrom && findFrom.isConnected && findFrom.focus) findFrom.focus({ preventScroll: true });
    tell();
  }
  $$('[data-find-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); if (b.hasAttribute('data-menu-close')) setMenu(false, true); setFind(true, b); }));
  $$('[data-find-close]').forEach((b) => b.addEventListener('click', () => setFind(false)));
  if (input) input.addEventListener('input', () => find.classList.toggle('has-query', input.value.trim().length > 0));
  if (find) find.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); setFind(false); return; }
    /* on a phone the search is a full-screen modal: Tab stays inside it (review 2026-09-28) */
    if (e.key !== 'Tab' || !window.matchMedia('(max-width: 989px)').matches) return;
    const f = $$('a[href],button:not([disabled]),input:not([type="hidden"])', find).filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  $$('.crk-find__chips [data-term]').forEach((a) => a.addEventListener('click', (e) => {
    /* a popular search fills the box, so the predictive results show before the full page */
    if (!input || e.metaKey || e.ctrlKey) return;
    e.preventDefault(); input.value = a.dataset.term; find.classList.add('has-query');
    input.dispatchEvent(new Event('input', { bubbles: true })); input.focus();
  }));
  document.addEventListener('keydown', (e) => {
    const t = e.target, typing = t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName));
    if (((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) || (e.key === '/' && !typing && !e.metaKey && !e.ctrlKey && !e.altKey)) {
      if (document.querySelector('cart-drawer.active, dialog[open]')) return;
      e.preventDefault(); setFind(true);
    } else if (e.key === 'Escape') {
      if ($('.crk-hdr__item.is-open')) closeAll();
    }
  });
  $$('[data-panels-close]').forEach((s) => s.addEventListener('click', () => { closeAll(); setFind(false); }));

  /* the pill's hint rotates through the popular searches */
  const hint = $('[data-hint]');
  const terms = $$('.crk-find__chips [data-term]').map((a) => a.dataset.term);
  if (hint && terms.length && !reduce) {
    const base = hint.textContent.trim();
    const list = [base].concat(terms.map((t) => 'Try "' + t + '"'));
    let k = 0, cur = hint.querySelector('span');
    setInterval(() => {
      if (document.hidden || wrap.classList.contains('is-finding')) return;
      k = (k + 1) % list.length;
      // Chrome holds animation frames while the window is covered and runs them together on return; the old code
      // then revealed two hints at once on top of each other (owner screenshot, 2026-10-02). Track the current hint,
      // drop anything a held timer left behind, and swap without waiting for a frame.
      hint.querySelectorAll('span').forEach((s) => { if (s !== cur) s.remove(); });
      const old = cur, nu = document.createElement('span');
      nu.textContent = list[k]; nu.className = 'is-in'; hint.appendChild(nu);
      void nu.offsetWidth;   // commit the start position so the slide still animates
      old.classList.add('is-out'); nu.classList.remove('is-in');
      cur = nu;
      setTimeout(() => old.remove(), 500);
    }, 3600);
  }

  /* ---------- the phone drawer ---------- */
  const dw = $('[data-dw]');
  let menuFrom = null;
  function setMenu(on, keepFocus) {
    if (!dw || on === wrap.classList.contains('is-menu')) return;
    wrap.classList.toggle('is-menu', on);
    doc.classList.toggle('crk-hdr-lock', on);
    $$('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', String(on)));
    if (on) {
      menuFrom = document.activeElement;
      loadImgs(dw);
      wrap.classList.remove('is-away');
      setTimeout(() => { const x = $('.crk-dw__x', dw); if (x) x.focus({ preventScroll: true }); }, reduce ? 0 : 80);
    } else if (!keepFocus && menuFrom && menuFrom.isConnected) menuFrom.focus({ preventScroll: true });
  }
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => setMenu(true)));
  $$('[data-menu-close]').forEach((b) => { if (!b.hasAttribute('data-find-open')) b.addEventListener('click', () => setMenu(false)); });
  if (dw) dw.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); setMenu(false); return; }
    if (e.key !== 'Tab') return;
    const f = $$('a[href],button,summary', dw).filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  window.matchMedia('(min-width: 990px)').addEventListener('change', (m) => { if (m.matches) setMenu(false, true); });

  /* ---------- the ticker below 1280px: one fact at a time ---------- */
  const facts = $$('.crk-tick li');
  if (facts.length > 1 && !reduce) {
    let f = 0;
    const narrow = window.matchMedia('(max-width: 1279px)');   /* the width below which the facts turn over (sections/header.liquid) */
    setInterval(() => {
      if (!narrow.matches || document.hidden) return;
      facts[f].classList.remove('is-on'); facts[f].classList.add('is-off');
      f = (f + 1) % facts.length;
      facts[f].classList.remove('is-off'); facts[f].classList.add('is-on');
    }, 3500);
  }
})();
